"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceNewLinesWithBreaks;

var _react = _interopRequireWildcard(require("react"));

function replaceNewLinesWithBreaks(text) {
  return text.split('\n').map(function (line, index) {
    return _react.default.createElement(_react.Fragment, {
      key: "question-notes-line-" + index
    }, line, _react.default.createElement("br", null));
  });
}

module.exports = exports.default;